import { render, staticRenderFns } from "./AdminSvg.vue?vue&type=template&id=29e3ecce&"
import script from "./AdminSvg.js?vue&type=script&lang=js&"
export * from "./AdminSvg.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports